module.exports = __webpack_public_path__ + "static/media/termostat_pm.b7eec8dd.pdf";